import { ArnValidConditionConfig } from '@arianee/arn-types';

export type ArnConditionConfig = Partial<ArnValidConditionConfig>;

export class ArnConditionConfigImpl implements ArnValidConditionConfig {
  constructor(
    readonly execute: {
      url: string;
    }
  ) {}
}
